import * as React from "react";
import { Popover, Progress, Table } from "antd";
import * as IssuedOrdersStore from "../store/IssuedOrders";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ApplicationState } from "../store";
import { ColumnsType } from "antd/lib/table";
import { CloseCircleFilled } from "@ant-design/icons";
import { IssuedOrder } from "../utils/scanner-backend";

type IssuedOrderListProps = IssuedOrdersStore.IssuedOrdersState & // ... state we've requested from the Redux store
  typeof IssuedOrdersStore.actionCreators; // ... plus action creators we've requested

let IssuedOrders = (props: IssuedOrderListProps) => {
  var { requestUnsatisfiedIssuedOrders } = props;
  React.useEffect(() => {
    requestUnsatisfiedIssuedOrders();
  }, [requestUnsatisfiedIssuedOrders]);

  const columns: ColumnsType<IssuedOrder> = [
    {
      title: "Stav",
      render: (order: IssuedOrder) => {
        const totalDelivered = order.Items.reduce(
          (total, item) =>
            total + Math.min(item.QuantityDelivered, item.QuantityOrdered),
          0
        );
        const totalOrdered = order.Items.reduce(
          (total, item) => total + item.QuantityOrdered,
          0
        );

        return (
          <Progress
            percent={Math.floor((totalDelivered / totalOrdered) * 100)}
          />
        );
      },
    },
    {
      title: "Firma",
      dataIndex: "CompanyName",
    },
    {
      title: "Číslo obj.",
      dataIndex: "Number",
      render: (orderNumber: string, order: IssuedOrder) => {
        const orderErrors = order.Errors ?? [];
        const orderIntakePath = `/order-intake/${encodeURIComponent(orderNumber)}`;

        if (orderErrors.length === 0) {
          return <Link to={orderIntakePath}>{orderNumber}</Link>;
        }

        return (
          <span>
            <Link to={orderIntakePath}>{orderNumber}</Link>{" "}
            <Popover
              content={orderErrors.map((e, i) => (
                <div key={i}>{e}</div>
              ))}
              title="Objednávka je chybná"
              trigger="hover"
            >
              <CloseCircleFilled style={{ color: "#ff4d4f" }} />
            </Popover>
          </span>
        );
      },
    },
  ];

  return (
    <div>
      <h1>Vydané objednávky</h1>
      <Table
        dataSource={props.issuedOrders}
        rowKey={(order) => order.Id}
        columns={columns}
        pagination={{ hideOnSinglePage: true }}
        loading={props.isLoading}
      />
    </div>
  );
};

export default connect(
  (state: ApplicationState) => state.unsatisfiedIssuedOrders, // Selects which state properties are merged into the component's props
  IssuedOrdersStore.actionCreators // Selects which action creators are merged into the component's props
)(IssuedOrders as any);
